// Harici bir ses dosyasina bagimli olmamak icin Web Audio API osilatoruyle
// kisa bir "ding ding" uretiyoruz. Tarayicinin otomatik ses politikasi
// yuzunden sayfa acilir acilmaz (kullanici hicbir yere tiklamadan) ilk
// cagrida ses cikmayabilir - AudioContext kullanicinin ilk etkilesiminden
// sonra "unlock" olur, sonraki cagrilarda normal calar.
let audioCtx = null;

const beep = (ctx, freq, startTime, duration) => {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, startTime);
  gain.gain.exponentialRampToValueAtTime(0.3, startTime + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(startTime);
  osc.stop(startTime + duration);
};

export const playNotificationSound = () => {
  try {
    if (!audioCtx) {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextClass) return;
      audioCtx = new AudioContextClass();
    }
    if (audioCtx.state === 'suspended') {
      audioCtx.resume().catch(() => {});
    }
    const now = audioCtx.currentTime;
    beep(audioCtx, 880, now, 0.12);
    beep(audioCtx, 1046.5, now + 0.16, 0.14);
  } catch {
    // Ses calinamazsa sessizce yut - bildirim zaten ekranda gorunmeye devam ediyor.
  }
};
